import { questionsLeftView } from '../shared/aiQuota';

/** Same sentence on every width. The cap and the count come from the caller. */
export default function QuestionsLeftNote({ used, limit, color }) {
  const view = questionsLeftView(used, limit);
  return (
    <p style={{ margin: '0 0 0.75rem', fontSize: '0.9rem', lineHeight: 1.4, color: color || 'inherit' }}>
      <span>{view.label}</span>
      {view.atLimit ? <span style={{ display: 'block' }}>{view.limitMessage}</span> : null}
    </p>
  );
}
